// SPDX-License-Identifier: AGPL-3.0-or-later

import type {Channel} from '@app/features/channel/models/Channel';
import {DataMenuRenderer} from '@app/features/ui/action_menu/DataMenuRenderer';
import {useCategoryMenuData} from '@app/features/ui/action_menu/items/CategoryMenuData';
import {MuteCategoryMenuItem} from '@app/features/ui/action_menu/items/CategoryMenuItems';
import {MenuGroup} from '@app/features/ui/action_menu/MenuGroup';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface CategoryContextMenuProps {
	category: Channel;
	onClose: () => void;
}
export const CategoryContextMenu: React.FC<CategoryContextMenuProps> = observer(({category, onClose}) => {
	const {t} = useLingui();
	const {groups} = useCategoryMenuData(category, {onClose});
	const excludeLabels = useMemo(() => [t`Mute Category`, t`Unmute Category`], [t]);
	return (
		<>
			<DataMenuRenderer groups={groups} excludeLabels={excludeLabels} />
			<MenuGroup>
				<MuteCategoryMenuItem category={category} onClose={onClose} />
			</MenuGroup>
		</>
	);
});
